export default function handlePaystack(transactionDetails) {
  console.log(transactionDetails.authorization_url)
  window.location = transactionDetails.authorization_url
}
